/** @module Enums */ /** typedoc */
var ServiceOffersKindEnum;
(function (ServiceOffersKindEnum) {
    /**
     * User use Legacy Billing for the service offer
     */
    ServiceOffersKindEnum["Legacy"] = "Legacy";
    /**
     * User use Fusebill Billing for the service offer
     */
    ServiceOffersKindEnum["Fusebill"] = "Fusebill";
})(ServiceOffersKindEnum || (ServiceOffersKindEnum = {}));

export { ServiceOffersKindEnum };
